import { EntityListSpecification } from './EntityListSpecification';
import { EntityListProductInputData } from '../entityListTypes';
import { EntityListItemType } from '@ydistri/api-sdk';
import { ProjectAdministrationSubpage } from '../../../projectAdministrationLib';
import { ProductEntityListContentStructure } from '../content_structure/ProductEntityListContentStructure';
import { EntityListProductItemConverter } from '../converters/EntityListProductItemConverter';
import { EntityListProductItemValidator } from '../validators/EntityListProductItemValidator';
import { ImportFormatItem } from '../../../../../lib/imports/importTypes';
import { ProductInputFormatProvider } from '../input_formats/ProductInputFormatProvider';

export class ProductEntityListSpecification extends EntityListSpecification<EntityListProductInputData> {
  public readonly itemType = EntityListItemType.Product;

  constructor() {
    super(
      {
        subpage: ProjectAdministrationSubpage.PRODUCTLISTS,
        pageTitle: 'Product list administration',
        title: 'Product list',
        menuOptionTitle: 'Product lists',
        shortName: 'PL',
      },
      new ProductEntityListContentStructure(),
      new EntityListProductItemConverter(),
      new EntityListProductItemValidator(),
      new ProductInputFormatProvider(),
    );
  }

  getUniqueItemsForDuplicateCheck(): ImportFormatItem<EntityListProductInputData>[] {
    return this.getInputFormat().filter(item => {
      return item.id === 'product';
    });
  }
}
